import { render, staticRenderFns } from "./MonitTaskList.vue?vue&type=template&id=04371255&scoped=true&"
import script from "./MonitTaskList.vue?vue&type=script&lang=js&"
export * from "./MonitTaskList.vue?vue&type=script&lang=js&"
import style0 from "./MonitTaskList.vue?vue&type=style&index=0&id=04371255&prod&lang=scss&"
import style1 from "./MonitTaskList.vue?vue&type=style&index=1&id=04371255&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04371255",
  null
  
)

export default component.exports